import service from '@/utils/request'

export function getServer() {
	return service.request({
		method: 'get',
		url: '/app/monitor/server',
	})
}
